import MarketingRepository from '@core/repositories/marketing.repo'
import UnificationRepository from '@core/repositories/accounts.repo'
import AccountsRepository from '@core/repositories/accounts.repo'
const resource = "/invitations"

export default {
  // Manage Users
  fetch(config){
    return MarketingRepository.get(`${resource}.json`, config)
  },
  create(payload){
    return MarketingRepository.post(`${resource}.json`, payload)
  },
  show(invitationId){
    return MarketingRepository.get(`${resource}/${invitationId}.json`)
  },
  update(invitationId, payload){
    return MarketingRepository.put(`${resource}/${invitationId}.json`, payload)
  },
  delete(invitationId){
    return MarketingRepository.delete(`${resource}/${invitationId}.json`)
  },
  fetchMembers(uid, config){
    return UnificationRepository.get(`/accounts/${uid}/members.json`, config)
  },
  getOwnerData(){
    return MarketingRepository.get(`owner.json`)
  },
  resendInvite(accountId,id){
    return AccountsRepository.post(`accounts/${accountId}/members/${id}/resend-verification`)
  }
}